import { render } from "./calendar_settings.svg.vue?vue&type=template&id=ff2cebf4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__